/*
 * @Author: your name
 * @Date: 2021-12-02 16:55:35
 * @LastEditTime: 2021-12-02 16:58:05
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \vue3-element-admin\src\store\modules\app\index.js
 */
import {
    TOGGLE_SLIDER,
    SET_TOKEN,
    SET_UNAME,
    SET_USER_INFO,
    SET_MENU_LIST,
    SET_PRODUCT,
    SET_BREADCRUMB_LIST,
    CLEAR_BREADCRUMB_LIST,
} from "./type.js";
export default {
    namespaced: true,
    state: {
        slider: {
            opened: JSON.parse(sessionStorage.getItem("opened")),
        },
        token: sessionStorage.getItem("token") || "",
        menuList: null,
        uname: sessionStorage.getItem("uname") || "",
        productList: [],
        breadcrumbList: [] // 面包屑导航列表
    },
    mutations: {
        [TOGGLE_SLIDER](state) {
            state.slider.opened = !state.slider.opened;
            sessionStorage.setItem(
                "opened",
                JSON.stringify(state.slider.opened)
            );
        },
        [SET_TOKEN](state, token) {
            state.token = token;
            sessionStorage.setItem("token", state.token);
        },
        [SET_UNAME](state, uname) {
            state.uname = uname;
            sessionStorage.setItem("uname", state.uname);
        },
        [SET_USER_INFO](state, userinfoStr) {
            sessionStorage.setItem("userinfo", userinfoStr);
        },
        [SET_MENU_LIST](state, menuList) {
            state.menuList = menuList;
        },
        [SET_PRODUCT](state, productList) {
            state.productList = productList
        },
        [SET_BREADCRUMB_LIST](state, breadcrumbList) {
            state.breadcrumbList = breadcrumbList;
        },
        [CLEAR_BREADCRUMB_LIST](state) {
            state.breadcrumbList = [];
        }
    },
    actions: {
        [TOGGLE_SLIDER]({ commit }) {
            commit(TOGGLE_SLIDER);
        },
        [SET_TOKEN]({ commit }, token) {
            commit(SET_TOKEN, token);
        },
        [SET_UNAME]({ commit }, uname) {
            commit(SET_UNAME, uname);
        },
        [SET_MENU_LIST]({ commit }, menuList) {
            commit(SET_MENU_LIST, menuList);
        },
        [SET_BREADCRUMB_LIST]({ commit }, breadcrumbList) {
            commit(SET_BREADCRUMB_LIST, breadcrumbList);
        },
        [CLEAR_BREADCRUMB_LIST]({ commit }) {
            commit(CLEAR_BREADCRUMB_LIST);
        }
    },
};
